import { STATUS } from "@/constant/statusConstants";

export const getCurrencyInitialValues = (showData) => ({
  code: showData?.data?.code || "",
  symbol: showData?.data?.symbol || "",
  name: showData?.data?.name || "",
  status: showData?.data?.status || STATUS.INACTIVE,
});
